/* eslint-disable react/prop-types */
import { useTranslation } from "react-i18next";
import "./MenuCustomerDisplaySwitches.css";

/**
 * Switches control what customers see on the app: ON = visible, OFF = hidden.
 * Maps to API: productImagesDisabled = !imagesShown, productPricesHidden = !pricesShown,
 * searchBarHidden = !searchShown. summaryButtonEnabled = summaryEnabled.
 */
export default function MenuCustomerDisplaySwitches({
  imagesShown,
  pricesShown,
  searchShown = true,
  summaryEnabled = false,
  onImagesShownChange,
  onPricesShownChange,
  onSearchShownChange,
  onSummaryEnabledChange,
  idPrefix = "menu",
}) {
  const { t } = useTranslation();

  return (
    <div className="mcds">
      <div className="mcds__header">
        <span className="mcds__header-icon" aria-hidden>
          <i className="fa fa-mobile" />
        </span>
        <div className="mcds__header-text">
          <div className="mcds__title">{t("customerMenuDisplay")}</div>
          <div className="mcds__subtitle">{t("customerMenuDisplaySubtitle")}</div>
        </div>
      </div>

      <div className="mcds__body">
        <ToggleRow
          icon="fa-picture-o"
          active={imagesShown}
          title={t("showProductImagesOnCustomerMenu")}
          hint={t("showProductImagesOnCustomerMenuHint")}
          inputId={`${idPrefix}-customer-images`}
          onChange={onImagesShownChange}
        />

        <ToggleRow
          icon="fa-tag"
          active={pricesShown}
          title={t("showProductPricesOnCustomerMenu")}
          hint={t("showProductPricesOnCustomerMenuHint")}
          inputId={`${idPrefix}-customer-prices`}
          onChange={onPricesShownChange}
        />

        {typeof onSearchShownChange === "function" && (
          <ToggleRow
            icon="fa-search"
            active={searchShown}
            title={t("showSearchBarOnCustomerMenu")}
            hint={t("showSearchBarOnCustomerMenuHint")}
            inputId={`${idPrefix}-customer-search`}
            onChange={onSearchShownChange}
          />
        )}

        {typeof onSummaryEnabledChange === "function" && (
          <ToggleRow
            icon="fa-list-ul"
            active={summaryEnabled}
            title={t("summaryButtonOnCustomerMenu")}
            hint={t("summaryButtonOnCustomerMenuHint")}
            inputId={`${idPrefix}-customer-summary`}
            onChange={onSummaryEnabledChange}
          />
        )}
      </div>
    </div>
  );
}

function ToggleRow({ icon, active, title, hint, inputId, onChange }) {
  return (
    <div className="mcds-toggle">
      <div className="mcds-toggle__row">
        <div className="mcds-toggle__left">
          <i
            className={`fa ${icon} mcds-toggle__fa ${active ? "mcds-toggle__fa--on" : "mcds-toggle__fa--off"}`}
            aria-hidden
          />
          <span className="mcds-toggle__label">{title}</span>
        </div>
        <div className="mcds-toggle__switch flex-shrink-0">
          <div className="form-check form-switch m-0 d-flex justify-content-end">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id={inputId}
              checked={active}
              onChange={(e) => onChange(e.target.checked)}
              aria-label={title}
            />
          </div>
        </div>
      </div>
      {hint ? <p className="mcds-toggle__hint">{hint}</p> : null}
    </div>
  );
}
